const getRemValue = (remValue) => (String(remValue).indexOf('rem')
    ? Number(String(remValue).slice(0, -3))
    : Number(remValue));
const remToPxValue = (remValue) => (getRemValue(remValue) * 16);
export default remToPxValue;
